export const capitalizeFirstLetter = (value: string): string => {
  if (!value || !value[0]) return value

  return value[0].toUpperCase() + value.slice(1)
}
